import React from 'react';
import styled from 'styled-components';
import { INamedFilterFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import { NamedFilterLabel } from '../../EntityLabels';
import { FauxInput } from '../../Form';
import useFilterWidgetFormContext from '../utils/useFilterWidgetFormContext';
import { defaultBasicFilterWidgetValues } from '../types';
import { IndexedIcon } from '../../Icon';
import { borderedContent } from '../../../styles/shareableStyles';

/**
 * This component will render a faux input with selected Named filter.
 *
 * There are only 2 possible things to do here:
 * 1). Remove Named filter (reset form to "basic")
 * 2). Confirm
 */

interface IProps {
  namedFilter: INamedFilterFieldsFragment;
}

const Container = styled.div`
  padding: 12px;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 240px;
  align-items: center;
  column-gap: 12px;
  padding: 12px;
  ${borderedContent};
`;

const FilterWidgetNamedView = ({ namedFilter }: IProps) => {
  const { reset } = useFilterWidgetFormContext();

  // In order to go back to "basic" form - user has to remove
  // a named filter in Named view. We will reset form to "basic" type
  // where user has to fill-in conditions and logic ops
  const handleRemove = () => {
    reset(defaultBasicFilterWidgetValues);
  };

  return (
    <Container>
      <Wrapper>
        <IndexedIcon name="filter" positiveIndex={1} isActive />
        <FauxInput>
          <NamedFilterLabel
            namedFilter={namedFilter}
            onRemoveNamedFilter={handleRemove}
          />
        </FauxInput>
      </Wrapper>
    </Container>
  );
};

export default FilterWidgetNamedView;
